import Button, { ButtonProps } from '@pelckmans/elementis/components/button';
import ButtonDropdown from '@pelckmans/elementis/components/button-dropdown';
import MaterialWordListIcon from '@pelckmans/elementis/icons/material-wordlist';
import { useTranslation } from 'react-i18next';
import useWordListApps from './hooks/useWordListApps';

export default function WordListAppButton({ size = 'md', emphasized }: Pick<ButtonProps, 'size' | 'emphasized'>) {
  const { t } = useTranslation();
  const { wordLists, openWordlist, getDisabledTooltipKey } = useWordListApps();

  if (wordLists.length === 0) return null;

  if (wordLists.length === 1) {
    const wordList = wordLists[0];
    const disabledTooltip = getDisabledTooltipKey(wordList);
    return (
      <Button
        key="word-list-button"
        startIcon={<MaterialWordListIcon data-testid="word-list-icon" />}
        prominence="secondary"
        size={size}
        emphasized={emphasized}
        onClick={() => openWordlist(wordList)}
        disabled={!!disabledTooltip}
        tooltip={disabledTooltip ? t(disabledTooltip) : undefined}
      >
        {t('PAGES.TOC_LEVEL.APPS.WORD_LIST.OPEN_WORD_LIST')}
      </Button>
    );
  }

  return (
    <ButtonDropdown
      title={t('PAGES.TOC_LEVEL.APPS.WORD_LIST.OPEN_WORD_LIST')}
      size={size}
      emphasized={emphasized}
      key="word-list-button"
      buttonProps={{
        prominence: 'secondary',
        startIcon: <MaterialWordListIcon data-testid="word-list-icon" />,
      }}
      disableBackgroundScroll
    >
      {wordLists.map(wordList => {
        const disabledTooltip = getDisabledTooltipKey(wordList);
        const disabledProps = disabledTooltip ? ({ disabled: true, tooltip: t(disabledTooltip) } as const) : {};

        return (
          <ButtonDropdown.Item
            as="button"
            key={wordList.id}
            value={wordList.id}
            text={wordList.name}
            textIcon={<MaterialWordListIcon data-testid={`word-list-icon-${wordList.id}`} />}
            onClick={() => openWordlist(wordList)}
            {...disabledProps}
          />
        );
      })}
    </ButtonDropdown>
  );
}
